module.exports = __webpack_public_path__ + "static/UEMSUNRISE-4799e8f378af545e7f771627287b576e.png";